module.exports = __webpack_public_path__ + "img/web6.7d96d05a.png";